'use strict';

/* eslint-disable */
// Require optional shared components
require(['componentLoader'], function (helper) {
  var config = THEHUT.config;
  // This site's module parameters
  helper.updateConfig({
    imageZoom: {
      bx_mode: 'horizontal',
      bx_controls: false,
      bx_pause: 4000,
      bx_infiniteLoop: false,
      bx_displaySlideQty: 4,
      bx_moveSlideQty: 4,
      bx_startingSlide: 0,
      bx_slideWidth: 150,
      bx_hideControlOnEnd: false,
      productArea: '.product-image-col .media',
      thumbnailSelector: '.product-image-col .product-thumbnails'
    }

  });

  // Make these modules dependencies
  helper.promote(['brandsSelection']);

  helper.requireDependencies();
});

define(['siteObj', 'fancyBox', 'common'], function (siteObj) {

  var lfint = {

    _initCurrencySelector: function _initCurrencySelector() {
      //Currency Selector Behaviours
      require(['CurrencySelection'], function (CurrencySelection) {
        window.cSelect = new CurrencySelection('li.currency');
      });
    },

    _initAccountCreationScript: function _initAccountCreationScript() {
      // account creation page script
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    },

    _initLoginPageScript: function _initLoginPageScript() {
      // login page scripts
      if (siteObj.page === 'login') {
        require(['loginPage']);
      }
    },

    _initFancyBoxDefaults: function _initFancyBoxDefaults() {
      $.fancybox.defaults = $.extend($.fancybox.defaults, {
        'height': 'autoSize',
        'width': 1010,
        'minWidth': 350,
        'maxWidth': 1010,
        'minHeight': 200,
        'margin': 0,
        'padding': 15,
        'overflow': 'visible'
      });
    },

    _initFancyBox: function _initFancyBox() {
      //todo what is this?
      if ($().fancybox) {
        var $question = $('.question'),
            $fbClose = $('.fb-close'),
            $selector = $('.fb'),
            $onLoadSelector = $('.fb-onload'),
            fancybox_opts = {
          'closeBtn': false,
          'init': function init($this, markup) {
            var content;
            if (markup === true) {
              content = $this.html();
            }
            $this.fancybox({
              'content': content,
              'onComplete': function onComplete() {
                fancybox_opts.events();
              },
              'afterShow': function afterShow() {
                fancybox_opts.events();
              },
              'onClosed': function onClosed() {
                fancybox_opts.cleanup();
              }
            });
          },
          'events': function events() {
            $fbClose.on('click', function (e) {
              e.preventDefault();
              $.fancybox.close(true);
            });
          },
          'cleanup': function cleanup() {
            $question.find('[data-answer]').unbind('click');
          }
        };

        fancybox_opts.init($selector);
        fancybox_opts.init($onLoadSelector, true);
        $onLoadSelector.click();
      }
    },

    _initGandalfScript: function _initGandalfScript() {
      // Gandalf
      if (siteObj.features.projectGandalf.active) {

        if (siteObj.sectionName === 'contact-us' || siteObj.page === 'contact-us') {
          require(['mvtBSContactP1']);
        }

        if (siteObj.page === 'customer-service') {
          require(['mvtBSContactP2']);
        }
      }

      if (siteObj.sectionName === 'customer-service') {
        require(['faq']);
      }
    },

    _initSalonMap: function _initSalonMap($salonMap) {
      // Function for populating the google maps on salon pages

      if ($salonMap.length) {

        if (siteObj.maps.postcode.length && siteObj.maps.postcode !== '') {

          siteObj.fn.loadmap = function () {

            var geocoder = new google.maps.Geocoder();

            var contentString = '<div class="info-window">' + '<h2>Find Us</h2>' + '<div class="salon-address"> ' + siteObj.maps.address + '</div>' + '<div class="info-window-description"> ' + siteObj.maps.description + '</div>' + '</div>';

            geocoder.geocode({
              'address': siteObj.maps.postcode
            }, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {

                var location = results[0].geometry.location,
                    lat = location.lat(),
                    lng = location.lng(),
                    latlng = new google.maps.LatLng(lat + 0.005, lng);

                var mapOptions = {
                  zoom: 15,
                  center: location,
                  mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

                map.panTo(latlng);

                var marker = new google.maps.Marker({
                  position: location,
                  map: map,
                  title: siteObj.maps.postcode
                });

                var infowindow = new google.maps.InfoWindow({
                  content: contentString
                });

                infowindow.open(map, marker);

                google.maps.event.addListener(marker, 'click', function () {
                  infowindow.open(map, marker);
                });
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
            });
          };

          siteObj.fn.loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyDAe9q-8nn_s6GdxTOsV1mI_JYpQR7wKuw&v=3.exp&sensor=false&callback=siteObj.fn.loadmap');
        }
      }
    },

    _init: function _init() {
      var $salonMap = $('#map-canvas');

      lfint._initCurrencySelector();

      lfint._initAccountCreationScript();

      lfint._initLoginPageScript();

      lfint._initFancyBoxDefaults();

      lfint._initFancyBox();

      lfint._initGandalfScript();

      lfint._initSalonMap($salonMap);

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }
  };

  lfint._init();
  return lfint;
});
//# sourceMappingURL=lfint.js.map
